import React, { useRef, useEffect } from 'react';
import { ReactComponent as IconPresenter } from "../../images/svg/presenter.svg";
import { ReactComponent as IconFullScreen } from "../../images/svg/full-screen.svg";

const ViewContextMenu = ({ isOpen, onClose }) => {
    const dialogRef = useRef(null);
    const [activeItem, setActiveItem] = React.useState('presenter');

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (event.target.closest('.context-menu-tileview .toolbox-button')) {
                return;
            }
            
            if (dialogRef.current && !dialogRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleItemClick = (itemName, e) => {
        e.stopPropagation();
        if (itemName === 'presenter' && document.fullscreenElement) {
            document.exitFullscreen();
        } else if (itemName === 'fullscreen') {
            document.documentElement.requestFullscreen().catch((e) => {
            });
        }
        setActiveItem(itemName);
    };

    return (
        <div className="view-context-menu" ref={dialogRef}>
            <div 
                className={`view-context-menu-item ${activeItem === 'presenter' ? 'active' : ''}`}
                onClick={(e) => handleItemClick('presenter', e)}
            >
                <div className="view-context-menu-item-icon">
                    <IconPresenter />
                </div>
                <div className="view-context-menu-item-text">
                    <span>Presenter View</span>
                </div>
            </div>
            <div 
                className={`view-context-menu-item ${activeItem === 'fullscreen' ? 'active' : ''}`}
                onClick={(e) => handleItemClick('fullscreen', e)}
            >
                <div className="view-context-menu-item-icon">
                    <IconFullScreen />
                </div>
                <div className="view-context-menu-item-text">
                    <span>Full Screen</span>
                </div>
            </div>
        </div>
    );
};

export default ViewContextMenu;